// extracted by mini-css-extract-plugin
export default {"container":"NotificationPopUp_container__bkRHj","closeBtn":"NotificationPopUp_closeBtn__11Lfm"};